import { h } from 'preact';
import styles from './StarRating.module.scss';
export function StarRating({ rating, size = 'large', starChecked, }) {
    const stars = [];
    for (let i = 1; i <= rating; i++) {
        stars.push(h("span", { key: i, className: `${styles.star} ${styles.filled} ${styles[size]} ${starChecked ? styles.starChecked : ''}` }, "\u2605"));
    }
    return h("div", { className: styles.starRating }, stars);
}
